module.exports = __webpack_public_path__ + "static/img/Desi Siti Maryam-close.64ba29f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Desi Siti Maryam-close.jpg
// module id = H+RS
// module chunks = 1